import React from 'react';
import { FuelButton, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useLoadJourneyHistory from '@hooks/useLoadJourneyHistory';
import { ErrorPropsInterface } from './ErrorTypes';
import * as Styled from './ErrorStyles';

function Error({ journeyId }: ErrorPropsInterface) {
  const { fetchHistory } = useLoadJourneyHistory({ journeyId });

  return (
    <Styled.Wrapper>
      <FuelSign icon="list-selection" size="large" />
      <FuelTypography size="heading-sm" weight="bold" spacingTop={16}>
        Histórico não encontrada
      </FuelTypography>
      <FuelTypography color="neutral-default" spacingTop={12}>
        Desculpe, o histórico não pode ser carregado no momento.
      </FuelTypography>
      <FuelFlex defaultProps={{ margin: 'km6', justifyContent: 'center' }}>
        <FuelButton size="large" onClick={fetchHistory}>
          Tentar novamente
        </FuelButton>
      </FuelFlex>
    </Styled.Wrapper>
  );
}

export default Error;
